import type { CityConfig } from "../city-template/types";

export const sanAngeloConfig: CityConfig = {
  city: "San Angelo",
  state: "Texas",
  stateAbbr: "TX",
  slug: "san-angelo",
  route: "/cities/san-angelo",
  title: "Emergency Passport San Angelo, TX | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in San Angelo, TX — as fast as 24 hours. Serving Tom Green County, Goodfellow AFB, and West Central Texas. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in San Angelo, TX",
  heroSubtitle: "Goodfellow AFB deployment orders? Angelo State University study abroad program? West Texas business trip to Mexico? We help San Angelo residents and military families get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20San%20Angelo%20Texas%20West%20Texas%20cityscape%20with%20Concho%20River%20winding%20through%20downtown%20historic%20buildings%20and%20Angelo%20State%20University%20campus%20at%20golden%20hour%20warm%20desert%20sunset%20colors%20dramatic%20West%20Texas%20sky%20professional%20drone%20photography&width=1800&height=700&seq=san-angelo-hero-tx-2026&orientation=landscape",
  heroImageAlt: "San Angelo Texas West Texas cityscape with Concho River at golden hour sunset",
  geoPosition: "31.4638;-100.4370",
  geoPlacename: "San Angelo, Texas",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "303 N Oregon Street, Suite 200, El Paso, TX 79901",
    distance: "Located in downtown El Paso — approximately 420 miles west of San Angelo via I-10",
  },
  nearbyCitiesZips: [
    { name: "San Angelo", zips: "76901–76909" },
    { name: "Wall", zips: "76957" },
    { name: "Grape Creek", zips: "76901" },
    { name: "Christoval", zips: "76935" },
    { name: "Mertzon", zips: "76941" },
    { name: "Eldorado", zips: "76936" },
    { name: "Ballinger", zips: "76821" },
    { name: "Winters", zips: "79567" },
    { name: "Abilene", zips: "79601–79608" },
    { name: "Midland", zips: "79701–79707" },
    { name: "Odessa", zips: "79760–79766" },
    { name: "Big Spring", zips: "79720, 79721" },
    { name: "Sweetwater", zips: "79556" },
    { name: "Brownwood", zips: "76801, 76802, 76803, 76804" },
    { name: "Brady", zips: "76825" },
    { name: "Sonora", zips: "76950" },
    { name: "Ozona", zips: "76943" },
    { name: "Junction", zips: "76849" },
    { name: "Kerrville", zips: "78028, 78029" },
    { name: "Austin", zips: "78701–78799" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent West Texas and military departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "West Texas Coverage", desc: "Serving San Angelo, Goodfellow AFB, and the Concho Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport services in El Paso, TX", route: "/cities/el-paso" },
    { name: "Fast passport renewal in Abilene, TX", route: "/cities/abilene" },
    { name: "Emergency passport help in Midland, TX", route: "/cities/midland-tx" },
    { name: "Urgent passport services in Odessa, TX", route: "/cities/odessa" },
    { name: "Passport courier services in Austin, TX", route: "/cities/austin" },
    { name: "Same-day passport help in Dallas, TX", route: "/cities/dallas" },
  ],
  fpcOfficeNote: "Fast Passport Center serves San Angelo remotely via secure courier. We do not have a walk-in office in San Angelo — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Tom Green County and the Concho Valley region, including Goodfellow AFB personnel.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Tom Green County and the Concho Valley including Irion, Coke, Runnels, and Concho counties",
  serviceAreaIntro: "From the historic Concho River walk and Fort Concho to the runways of Goodfellow Air Force Base, from the campus of Angelo State University to the oil fields of the Permian Basin, from the wind farms of Sweetwater to the cattle ranches of the Edwards Plateau — Fast Passport Center serves the entire San Angelo and West Central Texas region. We regularly help Tom Green County travelers, ASU students, and Goodfellow AFB personnel get their passports fast without the 6-hour drive to El Paso.",
  nearbyCitiesIntro: "We serve all San Angelo neighborhoods and the surrounding West Texas area including Wall, Grape Creek, Christoval, Mertzon, Eldorado, Ballinger, Winters, Abilene, Midland, Odessa, Big Spring, Sweetwater, Brownwood, Brady, Sonora, Ozona, Junction, and Kerrville. If you are anywhere in Tom Green County, the Concho Valley, or West Central Texas, we have you covered.",
  howItWorksIntro: "Most San Angelo travelers complete everything online and ship documents overnight. No need to drive 6 hours to El Paso or wait in line at the regional agency.",
  mistakesIntro: "San Angelo travelers are over 400 miles from the nearest regional passport agency in El Paso. Here are the most common mistakes that cause delays for West Texas residents.",
  testimonialsIntro: "San Angelo, Goodfellow AFB, and Concho Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in San Angelo? Here are the most common ones we hear from Concho Valley and West Texas travelers.",
  statePageRoute: "/states/texas",
  statePageName: "Texas",
  dmvWebsite: "https://www.dps.texas.gov",
  dmvLabel: "Texas DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For San Angelo travelers with immediate departure needs — as fast as 24 hours for urgent international flights and military orders.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Military deployment support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sgt. Michael T.",
      location: "Goodfellow AFB, San Angelo, TX",
      rating: 5,
      text: "Deployment orders to Germany came through fast. My passport had expired. Fast Passport Center had my renewal in 26 hours. The military family support was incredible — they understand deployment timelines.",
      service: "Passport Renewal",
    },
    {
      name: "Rebecca S.",
      location: "San Angelo, TX",
      rating: 5,
      text: "ASU study abroad program in Spain. Lost my passport the week before departure. Fast Passport Center had a replacement in 28 hours. They're lifesavers for Concho Valley students.",
      service: "Lost Passport",
    },
    {
      name: "David W.",
      location: "Christoval, TX",
      rating: 5,
      text: "First passport for my 14-year-old before a mission trip to Honduras. Fast Passport Center guided us through everything and had her passport in 4 days. So easy for West Texas families.",
      service: "Child Passport",
    },
    {
      name: "Linda G.",
      location: "San Angelo, TX",
      rating: 5,
      text: "Emergency passport for a family medical crisis in Mexico. Got it in 27 hours. Fast Passport Center handled everything — I didn't have to drive 6 hours to El Paso. Truly life-saving for West Texas residents.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "sanangelo-1",
      name: "San Angelo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 N Abe St",
      city: "San Angelo",
      state: "TX",
      zip: "76901",
      phone: "(325) 653-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown San Angelo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary San Angelo facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sanangelo-2",
      name: "San Angelo Southwest Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3201 Sherwood Way",
      city: "San Angelo",
      state: "TX",
      zip: "76901",
      phone: "(325) 653-2119",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest San Angelo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southwest San Angelo and Angelo State area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "sanangelo-3",
      name: "Tom Green County District Clerk",
      type: "Court Clerk Passport Acceptance",
      address: "112 W Beauregard Ave",
      city: "San Angelo",
      state: "TX",
      zip: "76903",
      phone: "(325) 659-6558",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown San Angelo Courthouse",
      website: "https://www.co.tom-green.tx.us/",
      websiteLabel: "Tom Green County District Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "sanangelo-4",
      name: "Goodfellow AFB Military Personnel Section",
      type: "Military Passport Processing",
      address: "310 Kearney Blvd, Bldg 310",
      city: "San Angelo",
      state: "TX",
      zip: "76908",
      phone: "(325) 654-3111",
      hours: "Mon–Fri: 7:30 AM – 4:30 PM",
      distance: "Goodfellow AFB — east San Angelo",
      website: "https://www.goodfellow.af.mil/",
      websiteLabel: "Goodfellow AFB Official Site",
      notes: "Available for active duty military personnel, dependents, and DOD civilians. Check with MPS for specific passport processing hours.",
      icon: "ri-shield-line",
    },
    {
      id: "sanangelo-5",
      name: "Abilene Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "341 Pine St",
      city: "Abilene",
      state: "TX",
      zip: "79601",
      phone: "(325) 673-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "90 miles northeast of San Angelo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Regional facility for West Central Texas. Full passport services available. Near Dyess AFB.",
      icon: "ri-mail-line",
    },
    {
      id: "sanangelo-6",
      name: "Midland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 E Wall St",
      city: "Midland",
      state: "TX",
      zip: "79701",
      phone: "(432) 686-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "115 miles west of San Angelo",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Permian Basin. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to El Paso", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "San Angelo photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Tom Green County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many San Angelo applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the El Paso regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many West Texas families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "San Angelo travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in San Angelo." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your San Angelo address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in San Angelo before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in San Angelo for travelers with urgent international flights and military deployment orders. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to El Paso." },
    { q: "How fast can I renew my passport in San Angelo?", a: "Fast Passport Center offers fast passport renewal in San Angelo in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent. We have extensive experience supporting Goodfellow AFB personnel." },
    { q: "What is the closest passport agency to San Angelo?", a: "The nearest regional passport agency to San Angelo is the El Paso Passport Agency, approximately 420 miles west via I-10. For urgent processing without the 6-hour drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from San Angelo without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near San Angelo?", a: "Same-day passport appointments are only available at the El Paso Regional Passport Agency — approximately 6 hours from San Angelo — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Tom Green County and West Texas residents." },
    { q: "Do you serve Goodfellow AFB and military families?", a: "Absolutely. Fast Passport Center serves Goodfellow AFB personnel and their families with expedited and emergency passport processing. We understand deployment timelines and TDY requirements. Our courier service works seamlessly for active duty, dependents, and DOD civilians stationed at Goodfellow." },
    { q: "Can I expedite a child passport in San Angelo?", a: "Yes. Fast Passport Center expedites child passports in San Angelo for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Concho Valley families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in San Angelo with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the El Paso Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — San Angelo", address: "1 N Abe St, San Angelo, TX 76901", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — San Angelo", address: "3201 Sherwood Way, San Angelo, TX 76901", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — San Angelo", address: "5501 Sherwood Way, San Angelo, TX 76901", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Abilene", address: "341 Pine St, Abilene, TX 79601", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — San Angelo", address: "4201 Sherwood Way, San Angelo, TX 76901", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Texas DPS — San Angelo",
      address: "4500 W Houston Harte Expy, San Angelo, TX 76901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Texas DPS — Abilene",
      address: "4649 S 1st St, Abilene, TX 79605",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Abilene, Dyess AFB, and West Central Texas. REAL ID available.",
      featured: false,
    },
    {
      name: "Texas DPS — Midland",
      address: "2405 E Front St, Midland, TX 79701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Permian Basin. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SJT",
      name: "San Angelo Regional Airport — Mathis Field",
      distance: "8 miles southwest of downtown San Angelo",
      address: "8618 Terminal Cir, San Angelo, TX 76904",
      note: "Regional airport serving the Concho Valley. Direct flights to Dallas/Fort Worth via American Eagle. About 15 minutes from downtown San Angelo.",
      flightUrl: "https://www.sanangelotexas.gov/airport",
      flightLabel: "SJT Airport",
      featured: true,
    },
    {
      code: "ABI",
      name: "Abilene Regional Airport",
      distance: "90 miles northeast of San Angelo",
      address: "2933 Airport Blvd, Abilene, TX 79602",
      note: "Regional airport serving West Central Texas. Direct flights to Dallas/Fort Worth. About 1.5 hours from San Angelo.",
      flightUrl: "https://www.abilenetx.gov/airport",
      flightLabel: "ABI Airport",
      featured: false,
    },
    {
      code: "MAF",
      name: "Midland International Air & Space Port",
      distance: "115 miles west of San Angelo",
      address: "5606 FM 307, Midland, TX 79706",
      note: "Larger regional airport serving Permian Basin. Direct flights to major hubs. About 2 hours from San Angelo.",
      flightUrl: "https://www.flymaf.com/",
      flightLabel: "MAF Airport",
      featured: false,
    },
  ],
};